<template>
<div class="AppFooter">
  <v-divider></v-divider>
  <div style="background: #fff">
    <v-row no-gutters justify="center" class="py-6">
      <v-col>
        <v-row no-gutters justify="center" class="mb-5">
          <div class="socialNetworld d-flex">
            <v-btn icon class="primary primaryIconSocial mx-3">
              <v-icon size="20" color="white" @click="openLink('https://www.facebook.com/Best-Golf-Courses-104130068610637')">fab fa-facebook-f</v-icon>
            </v-btn>
            <v-btn icon class="primary primaryIconSocial mx-3">
              <v-icon size="20" color="white">fab fa-instagram</v-icon>
            </v-btn>
          </div>
        </v-row>
        <v-row no-gutters justify="center" class="mb-3">
          <div class="shortTab d-flex flex-wrap align-center justify-center">
            <router-link :to="{ name: 'homepage' }" class="black--text mx-5 my-1 text-uppercase caption" v-translate>home</router-link>

            <router-link :to="{ name: 'newsfeed' }" class="black--text mx-5 my-1 text-uppercase caption" v-translate>news feed</router-link>

            <router-link :to="{ name: 'aboutUs' }" class="black--text mx-5 my-1 text-uppercase caption" v-translate>About</router-link>

            <router-link :to="{ name: 'ranking-worldwide', params:{top: 10} }" class="black--text mx-5 text-uppercase caption" v-translate>Golf courses</router-link>
            <router-link :to="{ name: 'coaches' }" class="black--text mx-5 my-1 text-uppercase caption" v-translate>Vloggers/Coaches</router-link>
            <router-link :to="{ name: 'player-finder' }" class="black--text mx-5 my-1 text-uppercase caption" v-translate>Player Finder</router-link>
            <router-link :to="{ name: 'community' }" class="black--text mx-5 my-1 text-uppercase caption" v-translate>Community</router-link>
            <router-link :to="{ name: 'selling' }" class="black--text mx-5 my-1 text-uppercase caption" v-translate>Services BGC for Golf Clubs</router-link>
            <router-link :to="{name: 'contact'}" class="black--text mx-5 my-1 text-uppercase caption" v-translate>Contact partnership</router-link>
          </div>
        </v-row>
        <v-row no-gutters justify="center">
          <div class="pl-3 pr-3 text-center tabInfo black--text mb-3">
            <router-link :to="{ name: 'rgpd' }" class="black--text caption d-inline-block mb-3" v-translate>RGPD</router-link>    |    
            <router-link :to="{ name: 'legal' }" class="black--text caption d-inline-block mb-3" v-translate>Legal mentions</router-link>    |    
            <router-link :to="{ name: 'terms' }" class="black--text caption d-inline-block mb-3" v-translate>Terms of use</router-link>      
          </div>
          <div class="ml-6 selectCountryFooter" v-if="!isCordova">
            <v-select
              :menu-props="{ contentClass: 'selectCountry' }"
              :items="links"
              :placeholder="$gettext('Change country')"
              item-value="id"
              item-text="name"
              style="font-size: 12px;color: #000;"
              hide-details outlined dense eager
              v-model="selectCountry"
            >
              <template v-slot:item="{item}">
                <v-btn text
                  class="hover-btn rounded-0"
                  :href="item.id == selectCountry ? '' : item.url"
                  :class="(item.id == selectCountry || (!item.id && selectCountry == 'staging-golf') || (!item.id && selectCountry == 'bestgolfcourse')) ? 'selected-btn' : ''"
                  plain :ripple="false"
                  @click.prevent.stop.capture="item.id == selectCountry ? '' : goToDomain(item)"
                >{{item.name}}</v-btn>
              </template>
            </v-select>
          </div>

        </v-row>
      </v-col>
    </v-row>
  </div>
  <p class="mb-0 text-center py-2 white--text caption" style="background: #000"><translate>Copyright</translate>©{{ $dayjs().year() }} Best Golf Course</p>
</div>
</template>
<script>
export default {
  name: "AppFooter",
  data() {
    return {};
  },
  computed: {
    prerendering() {
      return this.$store.getters.prerendering;
    },
    isCordova() {
      return window.cordova
    },
    currentHost() {
      if(this.prerendering) return 'bestgolfcourse.org'
      return location.host
              .replace('www.', '')
              .replace('fr.', '')
              .replace('www.fr.', '')
              .replace('uk.', '')
              .replace('www.uk.', '')
              .replace('vn.', '')
              .replace('www.vn.', '')
              .replace('au.', '')
              .replace('www.au.', '')
    },
    links() {
      return [
        {
          id: '', name: this.$gettext('Worldwide')
        },
        {
          id: 'vn', name: this.$gettext('Vietnam')
        },
        {
          id: 'fr', name: this.$gettext('France')
        },
        {
          id: 'au', name: this.$gettext('Australia')
        },
        {
          id: 'uk', name: this.$gettext('United Kingdom')
        }
      ].map(link => {
          const url = 'https://' + link.id + (link.id ? '.' : '') + this.currentHost
        return {...link, url}
      })
    },
    selectCountry() {
      return location.host.replace(this.currentHost, '').replace('.','')
    }
  },
  methods: {
    goToDomain(item) {
      if(location.host.indexOf('local') !== -1) {
        //return
      }
      const user = this.$store.state.auth.user
      const loginToken = user.id ? ('/login-token/' + user.email + '/' + this.$store.state.auth.token) : '';
      const newUrl = location.protocol + '//' + item.id + (item.id ? '.' : '') + this.currentHost + loginToken
      localStorage.removeItem('currentLanguage');
      document.location = newUrl
    },
    openLink(url) {
      if(this.isCordova) {
        window.open(url, '_system' , '_blank');
      } else {
        window.open(url, '_blank');
      }
    }
  }
};
</script>
